import { Typography } from '@material-ui/core';
import Breadcrumbs from "app/components/Breadcrumbs";
import DangerButton from "app/components/Button/DangerButton";
import PrimaryButton from "app/components/Button/PrimaryButton";
import { urlUserProfile } from "app/Layouts/AuthenticatedLayout/Sidebar/url";
import { Link, useHistory } from "react-router-dom";

export default function Toolbar({ id, setIsOpenDeleteAccountConfirmation, data }) {
  const history = useHistory();

  const handleGotoEditPage = () => {
    history.push({
      pathname: `${urlUserProfile}/edit/${id}`,
      state: data
    });
  }

  return (
    <div className="page-header">
      <div className="page-title">
        <Breadcrumbs>
          <Link to={urlUserProfile}>
            Tài khoản người dùng
          </Link>
          <Typography>{data?.email}</Typography>
        </Breadcrumbs>
      </div>
      <PrimaryButton
        onClick={handleGotoEditPage}
      >
        Chỉnh sửa
      </PrimaryButton>
      <DangerButton
        onClick={() => setIsOpenDeleteAccountConfirmation(true)}
      >
        Xoá TK
      </DangerButton>
    </div>
  )
}